<template>
  <div class="dashboard_body">
    <div>
      <p class="sci-ind-title">indicadores</p>
      <div class="sci-ind-dot">.</div>
    </div>
    <div class="row sci-ind-dash">
      <!-- INVESTIGADORES -->
      <div class="col-lg-4 col-md-6 col-sm-12">
        <div class="card card-stats card-height">
          <div class="card-body">
            <div class="row">
              <div class="col-3 col-md-2">
                <span class="material-icons sci-ind-icons">person_outline</span>
              </div>
              <div class="col-9 col-md-10 sci-ind-icon">
                <div class="numbers" style="text-align: left">
                  <p
                    class="card-category text-primary"
                    style="font-weight: bold"
                  >
                    INVESTIGADORES
                  </p>
                  <p
                    class="card-title"
                    style="
                      color: #33b2df;
                      font-weight: bold;
                      margin-block-end: 10px;
                    "
                  >
                    <animated-number
                      :value="indicadores.investigadores_total"
                      :formatValue="formatToPrice"
                      :duration="duration"
                    />
                  </p>
                  <p></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- ACADEMICAS     -->
      <div class="col-lg-4 col-md-6 col-sm-12">
        <div class="card card-stats card-height sci-ind-card">
          <div class="card-body">
            <div class="row">
              <div class="col-3 col-md-2">
                <span class="material-icons sci-ind-icons">school</span>
              </div>
              <div class="col-9 col-md-10 sci-ind-icon">
                <div class="numbers" style="text-align: left">
                  <p
                    class="card-category text-primary"
                    style="font-weight: bold"
                  >
                    INSTITUCIONES ACADÉMICAS
                  </p>
                  <p
                    class="card-title"
                    style="
                      color: #2b908f;
                      font-weight: bold;
                      margin-block-end: 10px;
                    "
                  >
                    <animated-number
                      :value="indicadores.academicas_total"
                      :formatValue="formatToPrice"
                      :duration="duration"
                    />
                  </p>
                  <p></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- ORGANIZACIONES -->
      <div class="col-lg-4 col-md-6 col-sm-12">
        <div class="card card-stats card-height sci-ind-card">
          <div class="card-body">
            <div class="row">
              <div class="col-3 col-md-2">
                <span class="material-icons sci-ind-icons">language</span>
              </div>
              <div class="col-9 col-md-10 sci-ind-icon">
                <div class="numbers" style="text-align: left">
                  <p
                    class="card-category text-primary"
                    style="font-weight: bold"
                  >
                    ORGANIZACIONES
                  </p>
                  <p
                    class="card-title"
                    style="
                      color: #13d8aa;
                      font-weight: bold;
                      margin-block-end: 10px;
                    "
                  >
                    <animated-number
                      :value="indicadores.organizaciones_total"
                      :formatValue="formatToPrice"
                      :duration="duration"
                    />
                  </p>
                  <p></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- INVESTIGADORES POR AREA -->
      <div class="col-lg-4 col-md-6 col-sm-12">
        <div class="card card-stats card-height sci-ind-card">
          <div class="card-body">
            <div class="row">
              <div class="col-3 col-md-2">
                <div class="icon-big text-center icon-warning">
                  <i
                    class="nc-icon nc-paper icon_card_invporarea"
                    style="color: white"
                  >
                    <span class="material-icons sci-ind-icons">biotech</span>
                  </i>
                </div>
              </div>
              <div
                class="col-9 col-md-10 sci-ind-icon"
                style="align-self: center"
              >
                <div class="numbers" style="text-align: left">
                  <p
                    class="card-category text-primary"
                    style="font-weight: bold"
                  >
                    INVESTIGADORES POR ÁREA
                  </p>
                  <p></p>
                </div>
              </div>
            </div>
            <div class="text-center">
              <indicador-investigadores-area :indicadores="indicadores"></indicador-investigadores-area>
            </div>
          </div>
        </div>
      </div>
      <!-- PROYECTOS POR AREA -->
      <div class="col-lg-4 col-md-6 col-sm-12">
        <div class="card card-stats card-height sci-ind-card">
          <div class="card-body">
            <div class="row">
              <div class="col-3 col-md-2">
                <div class="icon-big text-center icon-warning">
                  <i
                    class="nc-icon nc-paper icon_card_invporarea"
                    style="color: white"
                  >
                    <span class="material-icons sci-ind-icons2"
                      >account_tree</span
                    >
                  </i>
                </div>
              </div>
              <div
                class="col-9 col-md-10 sci-ind-icon"
                style="align-self: center"
              >
                <div class="numbers" style="text-align: left">
                  <p
                    class="card-category text-primary"
                    style="font-weight: bold"
                  >
                    PROYECTOS POR ÁREA
                  </p>
                  <p></p>
                </div>
              </div>
            </div>
            <div>
              <indicador-proyectos-area :indicadoresArea="indicadoresArea"></indicador-proyectos-area>
            </div>
          </div>
        </div>
      </div>
      <!-- TIPO DE ORGANIZACIONES -->
      <div class="col-lg-4 col-md-6 col-sm-12">
        <div class="card card-stats card-height sci-ind-card">
          <div class="card-body">
            <div class="row">
              <div class="col-3 col-md-2">
                <div class="icon-big text-center icon-warning">
                  <i
                    class="nc-icon nc-paper icon_card_invporarea"
                    style="color: white"
                  >
                    <span class="material-icons sci-ind-icons2"
                      >work_outline</span
                    >
                  </i>
                </div>
              </div>
              <div
                class="col-9 col-md-10"
                style="align-self: center"
              >
                <div class="numbers" style="text-align: left">
                  <p
                    class="card-category text-primary"
                    style="font-weight: bold"
                  >
                    TIPO DE ORGANIZACIONES
                  </p>
                  <p></p>
                </div>
              </div>
            </div>
            <div>
              <br />
              <br />
              <br />
              <indicador-organizaciones-tipo
                style="margin-block-end: 10px" :indicadores="indicadores"
              ></indicador-organizaciones-tipo>
              <br />
              <br />
              <br />
              <br />
            </div>
          </div>
        </div>
      </div>
      <!-- INVESTIGADORES POR GENERO -->
      <div class="col-lg-4 col-md-6 col-sm-12">
        <div class="card card-stats card-height sci-ind-card">
          <div class="card-body">
            <div class="row">
              <div class="col-3 col-md-2">
                <div class="icon-big text-center icon-warning">
                  <i
                    class="nc-icon nc-paper icon_card_invporarea"
                    style="color: white"
                  >
                    <span class="material-icons sci-ind-icons2">group</span>
                  </i>
                </div>
              </div>
              <div
                class="col-9 col-md-10 sci-ind-icon"
                style="align-self: center"
              >
                <div class="numbers" style="text-align: left">
                  <p
                    class="card-category text-primary"
                    style="font-weight: bold"
                  >
                    INVESTIGADORES POR GÉNERO
                  </p>
                  <p></p>
                </div>
              </div>
            </div>
            <div>
              <indicador-investigadores-genero :indicadores="indicadores"></indicador-investigadores-genero>
            </div>
          </div>
        </div>
      </div>
      <!-- INVESTIGADORES POR GRADO ACADEMICO -->
      <div class="col-lg-4 col-md-6 col-sm-12">
        <div class="card card-stats card-height sci-ind-card">
          <div class="card-body" style="margin-block-end: 12px">
            <div class="row">
              <div class="col-3 col-md-2">
                <div class="icon-big text-center icon-warning">
                  <i
                    class="nc-icon nc-paper icon_card_invporarea"
                    style="color: white"
                  >
                    <span class="material-icons sci-ind-icons2"
                      >cast_for_education</span
                    >
                  </i>
                </div>
              </div>
              <div
                class="col-9 col-md-10 sci-ind-icon"
                style="align-self: center"
              >
                <div class="numbers" style="text-align: left">
                  <p
                    class="card-category text-primary"
                    style="font-weight: bold"
                  >
                    INVESTIGADORES POR GRADO ACADÉMICO
                  </p>
                  <p></p>
                  <br />
                </div>
              </div>
            </div>
            <div>
              <indicador-investigadores-grado :indicadores="indicadores"></indicador-investigadores-grado>
            </div>
            <br />
          </div>
        </div>
      </div>

      <!-- POSTULACIONES -->
      <div class="col-lg-4 col-md-6 col-sm-12">
        <div class="card card-stats card-height sci-ind-card">
          <div class="card-body">
            <div class="row" style="margin-block-end: 20px">
              <div class="col-3 col-md-2">
                <div class="icon-big text-center icon-warning">
                  <i
                    class="nc-icon nc-paper icon_card_invporarea"
                    style="color: white"
                  >
                    <span class="material-icons sci-ind-icons2">grading</span>
                  </i>
                </div>
              </div>
              <div
                class="col-9 col-md-10 sci-ind-icon"
                style="align-self: center"
              >
                <div class="numbers" style="text-align: left">
                  <p
                    class="card-category text-primary"
                    style="font-weight: bold"
                  >
                    PROYECTOS APOYADOS POR COCyTED
                  </p>
                  <p></p>
                </div>
              </div>
            </div>
            <div>
              <indicador-proyectos-apoyados
                style="margin-block-end: 35px" :indicadores="indicadores"
              ></indicador-proyectos-apoyados>
              <!-- <postulaciones-indicador-component></postulaciones-indicador-component>     -->
            </div>
          </div>
        </div>
      </div>
      <IndicadoresAcademicos></IndicadoresAcademicos>
    </div>
  </div>
</template>

<script>
import IndicadorInvestigadoresArea from "./IndicadorInvestigadoresArea";
import IndicadorProyectosArea from "./IndicadorProyectosArea";
import IndicadorOrganizacionesTipo from "./IndicadorOrganizacionesTipo";
import IndicadorInvestigadoresGenero from "./IndicadorInvestigadoresGenero";
import IndicadorInvestigadoresGrado from "./IndicadorInvestigadoresGrado";
import IndicadorProyectosApoyados from "./IndicadorProyectosApoyados";
import IndicadoresAcademicos from "./AcademicasIndicadoresComponent.vue";

import axios from "axios";
import AnimatedNumber from "animated-number-vue";
export default {
  props: ["urlApi","configuracion"],
  components: {
    AnimatedNumber,
    IndicadorInvestigadoresArea,
    IndicadorProyectosArea,
    IndicadorOrganizacionesTipo,
    IndicadorInvestigadoresGenero,
    IndicadorInvestigadoresGrado,
    IndicadorProyectosApoyados,
    IndicadoresAcademicos,
  },
  name: "indicadores",
  data() {
    return {
      duration: 3000,
      indicadores: {},
      indicadoresArea: {}
    };
  },
  mounted() {
    var url = process.env.VUE_APP_API_URL + "/api/indicadores-totales";
    axios.get(url).then((response) => {
      this.indicadores = response.data;
    });
    var urlProyecto = process.env.VUE_APP_API_URL + "/api/indicador-por-area-proyecto-total";
    axios.get(urlProyecto).then((response) => {
      this.indicadoresArea = response.data;
    });
  },
  methods: {
    formatToPrice(value) {
      return `${Number(value).toFixed(0)}`;
    },
  },
  computed: {
    investigadores() {
      return this.investigador.length;
    },
    academicas() {
      return this.academica.length;
    },
    gubernamentales() {
      return this.gubernamental.length;
    },
    organizaciones() {
      return this.organizacion.length;
    },
    proyectos() {
      return this.proyecto.length;
    },
  },
};
</script>

<style scoped>
.dashboard_body {
  background-color: white;
}
.sci-ind-dash {
  width: 95%;
  margin: auto;
}
.sci-ind-title {
  margin: 3% auto 0%;
  text-transform: uppercase;
  color: rgba(255, 196, 0, 0.9);
  font-weight: bold;
  font-size: 2.3em;
}
.sci-ind-dot {
  font-weight: bold;
  color: rgba(0, 152, 255, 0.9);
  margin: 0rem 0 2rem 0;
}
.sci-ind-dot:before {
  content: "";
  display: inline-block;
  width: 90px;
  height: 1px;
  background: rgba(0, 0, 0, 0.5);
  margin-right: 1.2%;
  border-radius: 1px 1px;
}
.sci-ind-dot:after {
  content: "";
  display: inline-block;
  width: 90px;
  height: 1px;
  background: rgba(0, 0, 0, 0.5);
  margin-left: 1.2%;
  border-radius: 0 0 0 0;
}
.sci-ind-card {
  margin: 0.5rem 0;
}
.sci-ind-icon {
  margin: 0 0 0 1.5rem;
}
.sci-ind-icons {
  font-size: 56px;
  color: #2c3e50;
}
.sci-ind-icons2 {
  font-size: 42px;
  color: #2c3e50;
}
.col-md-10 {
  max-width: 69% !important;
}
.inv-btn {
  background: transparent;
  /* box-shadow: 6px 6px 14px 0 rgba(0, 0, 0, 0.2), -8px -8px 18px 0 rgb(255, 255, 255); */
  /* border-radius: 20px; */
  /* padding: 4px 30px 20px; */
  /* min-height: 120px; */
  /* min-width: 200px; */
  color: #00002e;
  /* margin-right: 20px; */
  text-transform: none;
}
.card-height {
  /* min-height: 200px; */
  background-color: #f4f3ef;
  border-radius: 10px;
}
.btn-card-rounded {
  background-color: #f4f3ef;
  background: transparent;
  box-shadow: 3px 3px 7px 0 rgba(0, 0, 0, 0.2),
    -4px -4px 9px 0 rgb(255, 255, 255);
  border-radius: 20px;
  color: #00002e;
  text-transform: none;
}
.btn-primary-inv:hover,
.btn-primary-inv:focus,
.btn-primary-inv:active,
.btn-primary-inv.active,
.open > .dropdown-toggle.btn-primary-inv {
  background-color: coral !important;
}
.btn-primary-org:hover,
.btn-primary-org:focus,
.btn-primary-org:active,
.btn-primary-org.active,
.open > .dropdown-toggle.btn-primary-org {
  background-color: rebeccapurple !important;
}
.btn-primary-aca:hover,
.btn-primary-aca:focus,
.btn-primary-aca:active,
.btn-primary-aca.active,
.open > .dropdown-toggle.btn-primary-aca {
  background-color: deepskyblue !important;
}
.btn-primary-gob:hover,
.btn-primary-gob:focus,
.btn-primary-gob:active,
.btn-primary-gob.active,
.open > .dropdown-toggle.btn-primary-gob {
  background-color: dodgerblue !important;
}
.btn-primary-proy:hover,
.btn-primary-proy:focus,
.btn-primary-proy:active,
.btn-primary-proy.active,
.open > .dropdown-toggle.btn-primary-proy {
  background-color: limegreen !important;
}
.icon_card_invporarea {
  /* box-shadow: inset 3px 3px 5px 0 rgba(0, 0, 0, 0.2), inset -3px -3px 5px 0 rgba(255, 255, 255, 0.5), 6px 6px 10px 0 rgba(0, 0, 0, 0.2), -6px -6px 10px 0 rgba(255, 255, 255, 0.5); */
  align-items: center;
  border-radius: 100px;
  display: flex;
  height: 5px;
  justify-content: center;
  width: 5px;
  border: solid 30px;
  /* background-color: gainsboro; */
  border-color: gainsboro;
}
.icon_card_postulaciones {
  /* box-shadow: inset 3px 3px 5px 0 rgba(0, 0, 0, 0.2), inset -3px -3px 5px 0 rgba(255, 255, 255, 0.5), 6px 6px 10px 0 rgba(0, 0, 0, 0.2), -6px -6px 10px 0 rgba(255, 255, 255, 0.5); */
  align-items: center;
  border-radius: 100px;
  display: flex;
  height: 5px;
  justify-content: center;
  width: 5px;
  border: solid 30px;
  background-color: #b2ff59;
  border-color: #b2ff59;
}
</style>
